module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "sitemap"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Mapa do Site")]), _c('p', [_vm._v("Aqui está a estrutura de informações do site")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "listagem lista"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Index'
      }
    }
  }, [_vm._v("Início")])], 1), _c('li', {
    staticClass: "item"
  }, [_vm._v("Institucional"), _c('ul', {
    staticClass: "listagem"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'apresentacao'
        }
      }
    }
  }, [_vm._v("Apresentação")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'acoes'
        }
      }
    }
  }, [_vm._v("Ações")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "https://calendar.google.com/calendar/embed?src=proadufrn%40gmail.com&ctz=America%2FFortaleza",
      "target": "_blank"
    }
  }, [_vm._v("Agenda Administrativa")])]), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'equipe'
        }
      }
    }
  }, [_vm._v("Equipe")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: 'organograma'
        }
      }
    }
  }, [_vm._v("Organograma")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Unidades'
      }
    }
  }, [_vm._v("Unidades")])], 1)])]), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Noticias'
      }
    }
  }, [_vm._v("Notícias")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Categorias'
      }
    }
  }, [_vm._v("Documentos")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Galeria'
      }
    }
  }, [_vm._v("Galeria")])], 1), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contato'
      }
    }
  }, [_vm._v("Fale conosco")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e693dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Sitemap.vue
// module id = 462
// module chunks = 0